import component from './card-form.vue';

export default function install(Vue, { name = undefined } = {}) {
  let n = component.name;
  if (name) {
    n = name;
  }
  Vue.component(n, component);
}
